// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ExpandableClamp__label":"bbk_a bhj_hg bhj_ry bhj_xj"};